const WebsiteDevelopment  = {
  "heroQuoteSection": {
      "enable": true,
      "title": "Mobile Application Development",
      "headline": "<strong>we build custom mobile apps</strong> to assist in the growth of your business.",
      "image": require('../images/app-dev/application_img-1.png'),
      "position": "right", //center, left or rightM
      "btnGrad" : "green",
      "class": "move-from-left"
  },
  "textWithImage":{
    "enable": true,
    "content": "Custom made mobile solutions driven by technology, nurtured by a team with a decade long experience to provide you with the perfect solution.",
    "image": require('../images/app-dev/application_img-2.png'),
    "position": "center", //center, left or rightM
    "class": "bounce-up-down-2",
    "portfolio": {
      "icons": [
        {
          "image": require('../svgs/apple-icon.svg'),
          "url": ""
        },
        {
          "image": require('../svgs/playstore-icon.svg'),
          "url": ""
        },
        {
          "image": require('../svgs/windows-icon.svg'),
          "url": ""
        }
      ],
      "class": "grad-green"
    }
  },  
  "headingWithGrid":{
    "enable": true,
    "title": "We are experts in",
    "blocks": [
      {
        "src": require('../images/app-dev/software-development.jpg'),
        "title": "SOFTWARE DEVELOPMENT",
        "url": "e-commerce/seo"
      },
      {
        "src": require('../images/app-dev/database-integrations.jpg'),
        "title": "DATABASE INTEGRATION",
        "url": "e-commerce/smm"
      },
      {
        "src": require('../images/app-dev/in-app-purchase.jpg'),
        "title": "IN-APP PURCHASE",
        "url": "e-commerce/ppc"
      },
      {
        "src": require('../images/app-dev/location-based-service.jpg'),
        "title": "LOCATION BASED SERVICE",
        "url": "e-commerce/analytics"
      }
    ]
  },
  "faq":{
    "enable": true,
    "title": "Frequently asked questions",
    "questions": [
      {
        "key": 1,
        "q": "How much does it cost to develop a Mobile App?",
        "a": "How much is dependent on what you are looking for. Like with anything else that’s custom built, the cost ranges from the requirements of the client. Simple mobile applications with basic functionalities begin at around $1500. However, an app that is going to add value to your business in the long run can cost anywhere from $30,000 to $150,000 depending on the complexity of design, functionality and features."
      }
    ]
  }
};

export default WebsiteDevelopment;